angular.module("questionarioAdv.module")
    .component("introduttiva", {
        templateUrl: "ng/components/questionarioAdv/introduttiva/introduttiva.view.html",
        bindings: {
            model: "=",
            exportValidationComponent: '&',
            listQuestions: '=',
            finalitaChanged: '&',
            isPagoDopo: '<'
        },
        controllerAs: 'introCtrl',
        controller: Introduttiva
    })

function Introduttiva(
    $scope,
    $timeout,
    $portalService
) {
    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            finalita: {},
            modalita: {},
            tipologia: {},
            formaGiur: {}
        }

        setDefaulValue();
        validateComponent();

    }


    var setDefaulValue = function () {
        self.supportModel.finalita = self.model.finalita.find(function (element) {
            return element.selected == true;
        })
        self.handleChange("finalita", self.supportModel.finalita)

        self.supportModel.modalita = self.model.modalita.find(function (element) {
            return element.selected == true;
        })
        self.handleChange("modalita", self.supportModel.modalita)

        self.supportModel.tipologia = self.model.tipologia.find(function (element) {
            return element.selected == true;
        })

        self.supportModel.formaGiur = self.model.formaGiuridica.find(function (element) {
            return element.selected == true;
        })
    }

    self.handleChange = function (tipo, valueSelected) {
        self.model[tipo].forEach(function (element) {
            if (valueSelected && element.value == valueSelected.value) {
                element.selected = true;
            } else {
                element.selected = false;
            }
        })

        if (tipo == "modalita" && valueSelected && !self.isPagoDopo && !$portalService.isAru()) {
            switch (valueSelected.name) {
                case "De visu Alba Leasing":
                case "Firma digitale":
                    Object.keys(self.listQuestions.note).forEach(function (key) {
                        if (key != 'id' && key != 'visible' && key != 'editable' && key != 'description' && key != 'noteCommon' && key != 'noteAlba' && key != 'annullato' && key != 'annullatoFe' && key != 'registrato' && key != 'riattivatoFe') {
                            self.listQuestions.note[key].visible = false;
                            Object.keys(self.listQuestions.note[key]).forEach(function (element) {
                                if (element != 'nomeCompilatore' && element != 'ndgCompilatore' && element != 'id' && element != 'description' && element != 'visible' && element != 'editable' && typeof self.listQuestions.note[key][element] != 'object') {
                                    self.listQuestions.note[key][element] = null;
                                }
                            })
                        }
                    })
                    self.listQuestions.note['noteAlba'].visible = true;
                    self.listQuestions.note['noteAlba'].editable = true;

                    break;

                case "De visu Agente":
                case "De visu Mediatore":
                    Object.keys(self.listQuestions.note).forEach(function (key) {
                        if (key != 'id' && key != 'visible' && key != 'editable' && key != 'description' && key != 'noteCommon' && key != 'noteAgentiMediatori' && key != 'annullato' && key != 'annullatoFe' && key != 'registrato' && key != 'riattivatoFe') {
                            self.listQuestions.note[key].visible = false;
                            Object.keys(self.listQuestions.note[key]).forEach(function (element) {
                                if (element != 'nomeCompilatore' && element != 'ndgCompilatore' && element != 'id' && element != 'description' && element != 'visible' && element != 'editable' && typeof self.listQuestions.note[key][element] != 'object') {
                                    self.listQuestions.note[key][element] = null;
                                }
                            })
                        }
                    })
                    self.listQuestions.note['noteAgentiMediatori'].visible = true;
                    self.listQuestions.note['noteAgentiMediatori'].editable = true;

                    break;

                case "De visu Fornitore":
                    Object.keys(self.listQuestions.note).forEach(function (key) {
                        if (key != 'id' && key != 'visible' && key != 'editable' && key != 'description' && key != 'noteCommon' && key != 'noteFornitore' && key != 'annullato' && key != 'annullatoFe' && key != 'registrato' && key != 'riattivatoFe') {
                            self.listQuestions.note[key].visible = false;
                            Object.keys(self.listQuestions.note[key]).forEach(function (element) {
                                if (element != 'nomeCompilatore' && element != 'ndgCompilatore' && element != 'id' && element != 'description' && element != 'visible' && element != 'editable' && typeof self.listQuestions.note[key][element] != 'object') {
                                    self.listQuestions.note[key][element] = null;
                                }
                            })
                        }
                    })
                    self.listQuestions.note['noteFornitore'].visible = true;
                    self.listQuestions.note['noteFornitore'].editable = true;

                    break;

                case "Direttamente dalla banca (presente rapporto continuativo in essere)":
                case "De visu Banca":
                    Object.keys(self.listQuestions.note).forEach(function (key) {
                        if (key != 'id' && key != 'visible' && key != 'editable' && key != 'description' && key != 'noteCommon' && key != 'noteBanca' && key != 'annullato' && key != 'annullatoFe' && key != 'registrato' && key != 'riattivatoFe') {
                            self.listQuestions.note[key].visible = false;
                            Object.keys(self.listQuestions.note[key]).forEach(function (element) {
                                if (element != 'nomeCompilatore' && element != 'ndgCompilatore' && element != 'id' && element != 'description' && element != 'visible' && element != 'editable' && typeof self.listQuestions.note[key][element] != 'object') {
                                    self.listQuestions.note[key][element] = null;
                                }
                            })
                        }
                    })
                    self.listQuestions.note['noteBanca'].visible = true;
                    self.listQuestions.note['noteBanca'].editable = true;

                    break;


                default:
                    break;
            }
        }

        if (tipo == 'finalita' && valueSelected) {
            if (valueSelected.name != "Aggiornamento  (Monitoraggio, Post Avvio, Riscatto, Moratoria)") {
                self.listQuestions.operazione.visible = true;
            } else {
                self.listQuestions.operazione.visible = false;
                self.listQuestions.operazione.area.forEach(function (element) {
                    element.selected = false;
                })
                self.listQuestions.operazione.finalita.forEach(function (element) {
                    element.selected = false;
                })
            }

        }

        self.finalitaChanged();
        validateComponent();
    }

    var validateComponent = function () {
        $timeout(function () {
            console.log("Il form introduttiva è:", $scope.introduttiva.$valid);

            self.exportValidationComponent({
                valid: $scope.introduttiva.$valid
            })

        }, 500)
    }

}